<wuc-display-field>
    <label>Ingangsdatum</label>
    <span>{{ purchasedProduct?.product.startDate | dateFormat }}</span>
</wuc-display-field>
